// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__lKXPO g-grid-container","divider":"style_divider__uuUNT"};